import { render, staticRenderFns } from "./MispickChallenge.vue?vue&type=template&id=01355aed&scoped=true&"
import script from "./MispickChallenge.vue?vue&type=script&lang=js&"
export * from "./MispickChallenge.vue?vue&type=script&lang=js&"
import style0 from "./MispickChallenge.vue?vue&type=style&index=0&id=01355aed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01355aed",
  null
  
)

export default component.exports